import * as React from "react";
import { Button } from "../ui/button";
import { X, ArrowLeft, FolderPlus, FilePlus } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

const modeTitles: { [key: string]: string } = {
  "create-category": "Add Category",
  "create-request": "Add Request",
  "edit-category": "Edit Category",
  "edit-request": "Edit Request",
};

interface GalleryHeaderProps {
  mode: string;
  handleBack: () => void;
  selectedCategoryId: string | null;
  currentParentId: string | null;
  handleBackToCategories: () => void;
  handleBackToParentCategory: () => void;
  selectedCategory: { name: string } | null;
  currentCategory: { name: string } | null;
  setMode: (
    mode: "list" | "create-category" | "create-request" | "edit-category" | "edit-request"
  ) => void;
  onClose: () => void;
}

const ListModeContent: React.FC<
  Pick<
    GalleryHeaderProps,
    | "selectedCategoryId"
    | "currentParentId"
    | "handleBackToCategories"
    | "handleBackToParentCategory"
    | "selectedCategory"
    | "currentCategory"
    | "setMode"
  >
> = ({
  selectedCategoryId,
  currentParentId,
  handleBackToCategories,
  handleBackToParentCategory,
  selectedCategory,
  currentCategory,
  setMode,
}) => (
  <>
    {(selectedCategoryId ?? currentParentId) != null && (
      <Button
        variant="ghost"
        size="icon"
        className="p-0 h-auto w-auto"
        onClick={selectedCategoryId != null ? handleBackToCategories : handleBackToParentCategory}
      >
        <ArrowLeft className="size-3.5" />
      </Button>
    )}
    <h3 className="text-sm font-semibold flex-1 truncate">
      {selectedCategory
        ? selectedCategory.name
        : currentCategory
          ? currentCategory.name
          : "Request Gallery"}
    </h3>
    <div className="flex gap-4">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="p-0 h-auto w-auto"
              onClick={() => setMode("create-category")}
            >
              <FolderPlus className="size-3.5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Add Category</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="p-0 h-auto w-auto"
              onClick={() => setMode("create-request")}
            >
              <FilePlus className="size-3.5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Add Request</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  </>
);

const GalleryHeader: React.FC<GalleryHeaderProps> = ({
  mode,
  handleBack,
  selectedCategoryId,
  currentParentId,
  handleBackToCategories,
  handleBackToParentCategory,
  selectedCategory,
  currentCategory,
  setMode,
  onClose,
}) => (
  <div className="p-2 border-b flex items-center justify-between gap-2">
    {mode !== "list" ? (
      <>
        <Button variant="ghost" size="icon" className="p-0 h-auto w-auto" onClick={handleBack}>
          <ArrowLeft className="size-3.5" />
        </Button>
        <h3 className="text-sm font-semibold flex-1 truncate">{modeTitles[mode]}</h3>
      </>
    ) : (
      <ListModeContent
        selectedCategoryId={selectedCategoryId}
        currentParentId={currentParentId}
        handleBackToCategories={handleBackToCategories}
        handleBackToParentCategory={handleBackToParentCategory}
        selectedCategory={selectedCategory}
        currentCategory={currentCategory}
        setMode={setMode}
      />
    )}
    <Button variant="ghost" size="icon" onClick={onClose}>
      <X className="w-5 h-5" />
    </Button>
  </div>
);

export default GalleryHeader;
